// DAS-3289: the "Ticker Alpha" line of an alert card, from the four values frozen on the alert
// at its first urgency scoring (alpha_signals_at_initiation, alpha_edge_at_initiation,
// alpha_signal_at_initiation, alpha_card_date_at_initiation). Pure: no fetch, no React.
// Returns null when the alert carries no card (older alerts, stocks without a stored card).

const SIGNAL_LABELS = {
  good_fund_buyers: 'good-fund buying',
  zacks_value_a: 'Zacks Value A',
  cheap_pe_sector: 'cheap P/E in sector',
  cheap_pe_after_stress: 'cheap P/E after a stressed month',
  small_cheap_pe: 'small company, cheap P/E',
  earnings_beat: 'earnings beat',
  earnings_miss: 'earnings miss',
};

const HORIZONS = {
  good_fund_buyers: '6 months',
  zacks_value_a: '6 months',
  cheap_pe_sector: '12 months',
  cheap_pe_after_stress: '12 months',
  small_cheap_pe: '6 months',
  earnings_beat: '6 months',
  earnings_miss: '6 months',
};

export function signalLabel(key) {
  return SIGNAL_LABELS[key] || key || 'signal';
}

// DAS-3308: direction-aware. A sell alert (Harvest) carries the stock's LAG signal when it has one (a reason to
// sell); a positive edge on a sell argues against it and says so. A negative edge on a buy argues against the buy.
export function isSellAlert(alert) {
  return String((alert && alert.alert_type) || '').trim().toLowerCase() === 'harvest';
}

export function tickerAlphaText(alert) {
  if (!alert) return null;
  const edge = alert.alpha_edge_at_initiation;
  if (edge === null || edge === undefined) return null;
  const date = alert.alpha_card_date_at_initiation ? String(alert.alpha_card_date_at_initiation).slice(0, 10) : null;
  const suffix = date ? `, card of ${date}` : '';
  const amount = Number(edge);
  if (!Number.isFinite(amount) || amount === 0) return `Ticker Alpha: none${suffix}`;
  const key = alert.alpha_signal_at_initiation;
  const horizon = HORIZONS[key] ? ` over ${HORIZONS[key]}` : '';
  const count = Number(alert.alpha_signals_at_initiation);
  const more = count > 1 ? `, ${count} signals` : '';
  const sell = isSellAlert(alert);
  if (amount > 0) {
    const against = sell ? ', argues against this sell' : '';
    return `Ticker Alpha: about €${Math.round(amount)} per €10,000${horizon} (${signalLabel(key)}${more})${against}${suffix}`;
  }
  const against = sell ? '' : ', argues against this buy';
  return `Ticker Alpha: lag of about €${Math.round(-amount)} per €10,000${horizon} (${signalLabel(key)}${more})${against}${suffix}`;
}

export default tickerAlphaText;
